import ReactGA from 'react-ga4';
import { UserGroup } from '~/services/analytics/userGroup';

export function setGaUserProperties(userGroup: UserGroup): void {
  ReactGA.gtag('set', 'user_properties', {
    user_group: userGroup,
  });
}
